export default __webpack_public_path__ + "static/media/rotate.3ded415e.svg";